import 'youtube-video-js';
import {findAll, onReady} from "../../../../modules/vegas/js/util";

function ready() {
	[...findAll('figure.media')].forEach((el) => {
		let $oembed = el.querySelector('oembed');

		if ($oembed) {
			let getVideo = $oembed.getAttribute('url');

			if (getVideo) {
				let video = document.createElement('youtube-video');
				video.setAttribute('src', getVideo);
				video.setAttribute('controls', '');
				video.setAttribute('autoplay', '');

				el.append(video);

				video.load().then(() => {
					const timer = setTimeout(function () {
						video.pause();

						let iframe = video.querySelector('iframe');
						if (iframe) {
							iframe.height = iframe.clientWidth * 55.8 / 100;

							window.addEventListener('resize', function () {
								iframe.height = iframe.clientWidth * 55.8 / 100;
							});
						}

						clearTimeout(timer);
					}, 1000);
				});
			} else {
				el.remove();
			}
		}

		$oembed.remove();
	});
}

onReady(ready);
